module.exports = __webpack_public_path__ + "img/MES5Indice3_cutout.e050ba27.png";